<script setup>
import { useForm } from "@inertiajs/vue3";

import VDevider from "@/Shared/VDevider.vue";

import VInputWithLabel from "@/Shared/Form/VInputWithLabel.vue";

import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";

const props = defineProps({
    initialValue: Object,
    urlSubmit: String,
    method: String,
});

const form = useForm({
    title: props.initialValue.title,
    _method: props.method,
});

const submit = () => {
    form.post(props.urlSubmit, {
        preserveScroll: true,
    });
};
</script>

<template>
    <form @submit.prevent="submit">
        <div class="row">
            <div class="col-lg-6 mb-3">
                <VInputWithLabel
                    elId="title"
                    label="District"
                    type="text"
                    :error="form.errors.title"
                    v-model:value="form.title"
                />
            </div>
        </div>
        <VDevider class="my-4" />

        <div class="text-end">
            <VButtonSubmit type="submit" :isProcessing="form.processing">
                Submit
            </VButtonSubmit>
        </div>
    </form>
</template>
